import { Theme } from '@mui/material'

const classes = {
  deviceInfoItem: { paddingY: 1, paddingX: 2, gap: 0.5, flexDirection: 'column' },
  deviceInfoLabel: (theme: Theme) => ({ fontWeight: 500, color: theme.palette.text.secondary }),
  deviceInfoValue: (theme: Theme) => ({ fcolor: theme.palette.text.secondary }),
  deviceInfoItemContainer: { rowGap: 0.5 },
}

export default classes
